/* eslint-disable no-param-reassign */
import {
  Select,
  Option,
  OptionGroup,
  Checkbox,
  Input,
  Tooltip,
  Message,
  MessageBox,
  DatePicker,
  Notification,
  Table,
  TableColumn,
  Pagination,
  Popover,
  Drawer,
  Loading,
  Radio,
  Button,
} from 'element-ui';
import element from '@/i18n';
import '@/assets/element-ui/theme/index.css';
import locale from 'element-ui/lib/locale';

locale.use(element.es.element);

export default ({ Vue }) => {
  Vue.use(Select, { locale });
  Vue.use(Option, { locale });
  Vue.use(OptionGroup, { locale });
  Vue.use(Checkbox, { locale });
  Vue.use(Input, { locale });
  Vue.use(Tooltip, { locale });
  Vue.use(DatePicker, { locale });
  Vue.use(Table, { locale });
  Vue.use(TableColumn, { locale });
  Vue.use(Pagination, { locale });
  Vue.use(Popover, { locale });
  Vue.use(Drawer, { locale });
  Vue.use(Loading, { locale });
  Vue.use(Radio, { locale });
  Vue.use(Button, { locale });
  Vue.prototype.$msgbox = MessageBox;
  Vue.prototype.$alert = MessageBox.alert;
  Vue.prototype.$confirm = MessageBox.confirm;
  Vue.prototype.$prompt = MessageBox.prompt;
  Vue.prototype.$notify = Notification;
  Vue.prototype.$message = Message;
};



// WEBPACK FOOTER //
// ./src/plugins/element.js